import React, { useEffect, useState } from 'react';
import './BuyPashuAhar.css';

const BuyPashuAhar = () => {
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState('');
  const [animalFilter, setAnimalFilter] = useState('');
  const [brandFilter, setBrandFilter] = useState('');
  const [priceRange, setPriceRange] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    fetch('https://api.agromanch.com/api/animals/pashu-ahar-buy')
      .then(res => res.json())
      .then(json => setData(json))
      .catch(err => console.error('Error:', err));
  }, []);

  const handleCardClick = (item) => {
    setSelectedItem(item);
    setSelectedVariant(null); // Don't auto-select any variant
    setCurrentImageIndex(0);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    setSelectedVariant(null);
    setCurrentImageIndex(0);
  };

  const handleBuy = (item) => {
    alert(`Buying ${item.name} for ₹${selectedVariant ? selectedVariant.sellingPrice : item.sellingPrice}`);
  };

  const handleShare = (item) => {
    if (navigator.share) {
      navigator.share({
        title: item.name,
        text: `Check out ${item.name} for ₹${selectedVariant ? selectedVariant.sellingPrice : item.sellingPrice}`,
        url: window.location.href
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      const shareText = `${item.name} - ₹${selectedVariant ? selectedVariant.sellingPrice : item.sellingPrice}\n${window.location.href}`;
      navigator.clipboard.writeText(shareText).then(() => {
        alert('Link copied to clipboard!');
      });
    }
  };

  const getPriceRange = (price) => {
    if (price <= 100) return 'Under ₹100';
    if (price <= 500) return '₹100 - ₹500';
    if (price <= 1000) return '₹500 - ₹1000';
    if (price <= 2000) return '₹1000 - ₹2000';
    return 'Above ₹2000';
  };

  const filtered = data
    .filter(item => {
      const matchesCategory = !categoryFilter || item.category === categoryFilter;
      const matchesAnimal = !animalFilter || item.animalType.includes(animalFilter);
      const matchesBrand = !brandFilter || item.brand === brandFilter;
      const matchesPrice = !priceRange || getPriceRange(item.price) === priceRange;
      const matchesSearch = !searchTerm || 
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.brand.toLowerCase().includes(searchTerm.toLowerCase());

      return matchesCategory && matchesAnimal && matchesBrand && matchesPrice && matchesSearch;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'price-low':
          return a.price - b.price;
        case 'price-high':
          return b.price - a.price;
        case 'name':
          return a.name.localeCompare(b.name);
        case 'brand':
          return a.brand.localeCompare(b.brand);
        default:
          return 0;
      }
    });

  const uniqueCategories = [...new Set(data.map(item => item.category))];
  const uniqueAnimals = [...new Set(data.flatMap(item => item.animalType))];
  const uniqueBrands = [...new Set(data.map(item => item.brand))];
  const priceRanges = ['Under ₹100', '₹100 - ₹500', '₹500 - ₹1000', '₹1000 - ₹2000', 'Above ₹2000'];

  const nextImage = () => {
    if (selectedItem && selectedItem.images && selectedItem.images.length > 0) {
      setCurrentImageIndex((prev) => 
        prev === selectedItem.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedItem && selectedItem.images && selectedItem.images.length > 0) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? selectedItem.images.length - 1 : prev - 1
      );
    }
  };

  // Add function to calculate savings
  const calculateSavings = (mrp, sellingPrice) => {
    if (mrp && sellingPrice && mrp > sellingPrice) {
      return mrp - sellingPrice;
    }
    return 0;
  };

  return (
    <div className="buy-pashu-ahar">
      <div className="filter-section">
      
      
        <div className="filter-controls">
          <div className="filter-group">
            <label>Category:</label>
            <select 
              value={categoryFilter} 
              onChange={e => setCategoryFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">All Categories</option>
              {uniqueCategories.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Animal Type:</label>
            <select 
              value={animalFilter} 
              onChange={e => setAnimalFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">All Animals</option>
              {uniqueAnimals.map(animal => (
                <option key={animal} value={animal}>{animal}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Brand:</label>
            <select 
              value={brandFilter} 
              onChange={e => setBrandFilter(e.target.value)}
              className="filter-select"
            >
              <option value="">All Brands</option>
              {uniqueBrands.map(brand => (
                <option key={brand} value={brand}>{brand}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Price Range:</label>
            <select 
              value={priceRange} 
              onChange={e => setPriceRange(e.target.value)}
              className="filter-select"
            >
              <option value="">All Prices</option>
              {priceRanges.map(range => (
                <option key={range} value={range}>{range}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Sort By:</label>
            <select 
              value={sortBy} 
              onChange={e => setSortBy(e.target.value)}
              className="filter-select"
            >
              <option value="name">Name</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="brand">Brand</option>
            </select>
          </div>
        </div>

        <div className="results-info">
          <span>📦 {filtered.length} products found</span>
          <button 
            onClick={() => {
              setCategoryFilter('');
              setAnimalFilter('');
              setBrandFilter('');
              setPriceRange('');
              setSearchTerm('');
              setSortBy('name');
            }}
            className="clear-filters-btn"
          >
            🗑️ Clear All Filters
          </button>
        </div>
      </div>

      <div className="card-grid">
        {filtered.map(item => (
          <div key={item._id} className="product-card" onClick={() => handleCardClick(item)}>
            <div className="card-image-container">
              <img 
                src={item.images && item.images.length > 0 ? item.images[0] : "https://via.placeholder.com/300x200?text=Product+Image"} 
                alt={item.name} 
                className="card-img"
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = "https://via.placeholder.com/300x200?text=Product+Image";
                }}
              />
            </div>

            <div className="card-content">
              <div className="card-header">
                <h3 className="card-title">{item.name}</h3>
                <p className="card-brand">🏷️ {item.brand}</p>
              </div>
              
              <div className="card-price-section">
                {item.discount && (
                  <span className="discount-badge">{item.discount}% Off</span>
                )}
                {item.mrp && (
                  <span className="mrp-price">₹{item.mrp}</span>
                )}
                {item.sellingPrice && (
                  <span className="selling-price">₹{item.sellingPrice}</span>
                )}
                <span className="price-unit">/ {item.priceUnit}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="no-results">
          <h3>🔍 No products found</h3>
          <p>Try adjusting your filters or search terms</p>
        </div>
      )}

      {/* Modal for Product Details */}
      {showModal && selectedItem && (
        <>
          <div className="modal-overlay" onClick={closeModal}></div>
          <div className="product-details-modal">
            <button className="modal-close" onClick={closeModal}>✕</button>
            
            <div className="modal-header">
              <h2 className="modal-title">{selectedItem.name}</h2>
              <p className="modal-manufacturer">🏭 {selectedItem.manufacturer}</p>
              <p className="modal-brand">🏷️ {selectedItem.brand}</p>
            </div>
            
            {/* Image Gallery */}
            {selectedItem.images && selectedItem.images.length > 0 && (
              <div className="modal-image-gallery">
                <button className="gallery-nav prev" onClick={prevImage}>‹</button>
                <img 
                  src={selectedItem.images[currentImageIndex]} 
                  alt={`${selectedItem.name} - Image ${currentImageIndex + 1}`}
                  className="gallery-image"
                />
                <button className="gallery-nav next" onClick={nextImage}>›</button>
                <div className="image-indicators">
                  {selectedItem.images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => setCurrentImageIndex(index)}
                    />
                  ))}
                </div>
              </div>
            )}
            
            <div className="modal-price-section">
              {selectedVariant ? (
                <>
                  {selectedVariant.discount && (
                    <span className="discount-badge">{selectedVariant.discount}% Off</span>
                  )}
                  {selectedVariant.mrp && (
                    <span className="mrp-price">₹{selectedVariant.mrp}</span>
                  )}
                  {selectedVariant.sellingPrice && (
                    <span className="selling-price">₹{selectedVariant.sellingPrice}</span>
                  )}
                </>
              ) : (
                <>
                  {selectedItem.discount && (
                    <span className="discount-badge">{selectedItem.discount}% Off</span>
                  )}
                  {selectedItem.mrp && (
                    <span className="mrp-price">₹{selectedItem.mrp}</span>
                  )}
                  {selectedItem.sellingPrice && (
                    <span className="selling-price">₹{selectedItem.sellingPrice}</span>
                  )}
                </>
              )}
              <span className="price-unit">/ {selectedItem.priceUnit}</span>
            </div>
            
            {/* Variants Selection */}
            {selectedItem.variants && selectedItem.variants.length > 0 && (
              <div className="modal-variants">
                <h3 className="variants-title">Select Pack Size</h3>
                <div className="variants-grid">
                  {selectedItem.variants.map((variant, index) => {
                    const savings = calculateSavings(variant.mrp, variant.sellingPrice);
                    return (
                      <button
                        key={index}
                        className={`variant-btn ${selectedVariant === variant ? 'active' : ''}`}
                        onClick={() => setSelectedVariant(variant)}
                      >
                        <span className="variant-name">{variant.name}</span>
                        <span className="variant-price">₹{variant.sellingPrice}</span>
                        {savings > 0 && (
                          <span className="variant-savings">Save ₹{savings}</span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            
            {/* Show selected variant details */}
            {selectedVariant && (
              <div className="selected-variant-details">
                <h3 className="variant-details-title">Selected: {selectedVariant.name}</h3>
                <div className="variant-details-grid">
                  <div className="variant-detail-item">
                    <span className="detail-label">MRP:</span>
                    <span className="detail-value mrp">₹{selectedVariant.mrp}</span>
                  </div>
                  <div className="variant-detail-item">
                    <span className="detail-label">Selling Price:</span>
                    <span className="detail-value selling-price">₹{selectedVariant.sellingPrice}</span>
                  </div>
                  <div className="variant-detail-item">
                    <span className="detail-label">Discount:</span>
                    <span className="detail-value discount">{selectedVariant.discount}%</span>
                  </div>
                  <div className="variant-detail-item">
                    <span className="detail-label">You Save:</span>
                    <span className="detail-value savings">₹{calculateSavings(selectedVariant.mrp, selectedVariant.sellingPrice)}</span>
                  </div>
                  <div className="variant-detail-item">
                    <span className="detail-label">Available:</span>
                    <span className="detail-value">{selectedVariant.availableQuantity} {selectedItem.priceUnit}</span>
                  </div>
                </div>
              </div>
            )}

            <div className="modal-description">
              <h3 className="description-title">Product Description</h3>
              <p className="description-text">{selectedItem.description}</p>
            </div>
            
            <div className="modal-highlights">
              <h3 className="highlights-title">Product Details</h3>
              
              <div className="highlights-grid">
                <div className="highlight-row">
                  <span className="highlight-label">Category</span>
                  <span className="highlight-value">{selectedItem.category}</span>
                </div>
                
                <div className="highlight-row">
                  <span className="highlight-label">Animal Type</span>
                  <span className="highlight-value">{selectedItem.animalType.join(', ')}</span>
                </div>
                
                <div className="highlight-row">
                  <span className="highlight-label">Ingredients</span>
                  <span className="highlight-value">{selectedItem.ingredients.join(', ')}</span>
                </div>
                
                <div className="highlight-row">
                  <span className="highlight-label">Available Quantity</span>
                  <span className="highlight-value">
                    {selectedVariant ? selectedVariant.availableQuantity : selectedItem.availableQuantity} {selectedItem.priceUnit}
                  </span>
                </div>
                
                <div className="highlight-row">
                  <span className="highlight-label">Manufacturing Date</span>
                  <span className="highlight-value">{selectedItem.manufacturingDate.slice(0, 10)}</span>
                </div>
                
                <div className="highlight-row">
                  <span className="highlight-label">Expiry Date</span>
                  <span className="highlight-value">{selectedItem.expiryDate.slice(0, 10)}</span>
                </div>
              </div>
            </div>
            
            <div className="modal-nutrition">
              <h3 className="nutrition-title">Nutritional Information</h3>
              <div className="nutrition-grid">
                <div className="nutrition-item">
                  <span>Protein</span>
                  <span>{selectedItem.nutritionalValue.protein}%</span>
                </div>
                <div className="nutrition-item">
                  <span>Fat</span>
                  <span>{selectedItem.nutritionalValue.fat}%</span>
                </div>
                <div className="nutrition-item">
                  <span>Fiber</span>
                  <span>{selectedItem.nutritionalValue.fiber}%</span>
                </div>
                <div className="nutrition-item">
                  <span>Moisture</span>
                  <span>{selectedItem.nutritionalValue.moisture}%</span>
                </div>
              </div>
            </div>

            <div className="modal-actions">
              <button className="close-btn" onClick={closeModal}>
                Close
              </button>
              <button 
                className="add-to-cart-btn"
                onClick={() => {
                  handleBuy(selectedItem);
                  closeModal();
                }}
              >
                🛒 Add to Cart
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BuyPashuAhar;